import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "day-number" }
const _hoisted_2 = {
  key: 0,
  class: "hours-container"
}
const _hoisted_3 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_4 = { class: "day-park" }
const _hoisted_5 = {
  key: 0,
  class: "day-hours"
}
const _hoisted_6 = {
  key: 1,
  class: "day-hours"
}
const _hoisted_7 = {
  key: 2,
  class: "day-hours"
}
const _hoisted_8 = {
  key: 3,
  class: "day-hours"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "day-hours"
}
const _hoisted_12 = {
  key: 1,
  class: "day-hours"
}
const _hoisted_13 = {
  key: 2,
  class: "day-hours"
}
const _hoisted_14 = {
  key: 3,
  class: "day-hours"
}
const _hoisted_15 = { class: "purchase-container mt-3 mb-3 mr-1" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ticket-alt" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "featured-container"
}
const _hoisted_21 = {
  key: 0,
  class: "darkText"
}
const _hoisted_22 = ["href"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["cal-day curr-month", { 'prev-day': _ctx.dayIsPast, 'today-day': _ctx.dayIsToday, 'future-day': _ctx.dayIsFuture }])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.day.day), 1),
    (!_ctx.dayIsPast)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operatingDay.operatingSchedules, (opSchedule) => {
            return (_openBlock(), _createElementBlock("div", {
              key: opSchedule.extCalendarId,
              class: "mb-1"
            }, [
              (opSchedule.isClosed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.resolvePark(opSchedule.extCalendarId).displayName), 1),
                    (opSchedule.isClosed)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.resolvePark(opSchedule.extCalendarId).closedText), 1))
                      : (opSchedule.isAllDay)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.resolvePark(opSchedule.extCalendarId).allDayText), 1))
                        : (opSchedule.isTbd)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.resolvePark(opSchedule.extCalendarId).tbdText), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(opSchedule.from) + " — " + _toDisplayString(opSchedule.to), 1))
                  ]))
                : _createCommentVNode("", true),
              (!opSchedule.isClosed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _createElementVNode("a", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navToDetail && _ctx.navToDetail(...args)))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.resolvePark(opSchedule.extCalendarId).displayName) + " ", 1),
                      _hoisted_10
                    ]),
                    (opSchedule.isClosed)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.resolvePark(opSchedule.extCalendarId).closedText), 1))
                      : (opSchedule.isAllDay)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.resolvePark(opSchedule.extCalendarId).allDayText), 1))
                        : (opSchedule.isTbd)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.resolvePark(opSchedule.extCalendarId).tbdText), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(opSchedule.from) + " — " + _toDisplayString(opSchedule.to), 1))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      (_ctx.operatingDay.operatingSchedules[0] && !_ctx.operatingDay.operatingSchedules[0].isClosed && !_ctx.operatingDay.operatingSchedules[0].isTbd)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            (_ctx.purchaseCTAName)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _ctx.purchaseCTAName,
                  style: {"float":"right"}
                }, _hoisted_19, 8, _hoisted_17))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.dayIsPast)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operatingDay.featuredSchedules, (featSchedule) => {
            return (_openBlock(), _createElementBlock("div", {
              key: featSchedule.extCalendarId
            }, [
              _createElementVNode("div", {
                class: "featured",
                style: _normalizeStyle({background: _ctx.resolveActivity(featSchedule.extCalendarId).featuredColor} )
              }, [
                (_ctx.resolveActivity(featSchedule.extCalendarId).featuredTextDark)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("a", {
                        href: _ctx.resolveActivity(featSchedule.extCalendarId).activityUrl
                      }, _toDisplayString(_ctx.resolveActivity(featSchedule.extCalendarId).displayName), 9, _hoisted_22)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.resolveActivity(featSchedule.extCalendarId).featuredTextDark)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("a", {
                        href: _ctx.resolveActivity(featSchedule.extCalendarId).activityUrl
                      }, _toDisplayString(_ctx.resolveActivity(featSchedule.extCalendarId).displayName), 9, _hoisted_24)
                    ]))
                  : _createCommentVNode("", true)
              ], 4)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}